export default __webpack_public_path__ + "static/media/wrapper-tilted.c7040e24fd0c947b227eca871b1a9c4e.svg";